import './bootstrap';
import { initDateScrollPickers } from './date-scroll-picker';

import Alpine from 'alpinejs';

window.Alpine = Alpine;
Alpine.start();

// 本番ビルドの tree-shake で date-scroll-picker が落ちないよう明示的に初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDateScrollPickers);
} else {
  initDateScrollPickers();
}
